module.exports = __webpack_public_path__ + "static/media/dena.46891191.png";